/** `expo-secure-store` → localStorage com prefixo. Na Fase 2 a chave de dados ganha cofre próprio. */
const PREFIX = 'kontto-web:secure:';
const mem = new Map<string, string>();
const store = (): Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> => {
  try {
    if (typeof localStorage !== 'undefined') return localStorage;
  } catch {}
  return { getItem: (k) => mem.get(k) ?? null, setItem: (k, v) => void mem.set(k, v), removeItem: (k) => void mem.delete(k) };
};
export async function getItemAsync(key: string): Promise<string | null> { return store().getItem(PREFIX + key); }
export async function setItemAsync(key: string, value: string): Promise<void> { store().setItem(PREFIX + key, value); }
export async function deleteItemAsync(key: string): Promise<void> { store().removeItem(PREFIX + key); }
export function getItem(key: string): string | null { return store().getItem(PREFIX + key); }
export function setItem(key: string, value: string): void { store().setItem(PREFIX + key, value); }
export async function isAvailableAsync(): Promise<boolean> { return true; }
export const WHEN_UNLOCKED = 'WHEN_UNLOCKED';
